import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, ArrowLeft, Search, Phone } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";

export default function NotFoundPage() {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4" data-testid="not-found-page">
      <Card className="max-w-lg w-full text-center">
        <CardContent className="pt-12 pb-8">
          {/* 404 Icon */}
          <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-primary/10 flex items-center justify-center">
            <Search className="w-12 h-12 text-primary" />
          </div>
          
          {/* Error Code */}
          <h1 className="text-6xl font-bold text-primary mb-4" data-testid="404-code">404</h1>
          
          {/* Title */}
          <h2 className="text-2xl font-semibold mb-2" data-testid="404-title">
            {t("notFound.title", "Page Not Found")}
          </h2>
          
          {/* Description */}
          <p className="text-muted-foreground mb-8" data-testid="404-description">
            {t("notFound.description", "Sorry, the page you're looking for doesn't exist or has been moved.")}
          </p>
          
          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild>
              <Link to="/" data-testid="404-home-btn">
                <Home className="w-4 h-4 mr-2" />
                {t("notFound.goHome", "Go Home")}
              </Link>
            </Button>
            
            <Button variant="outline" asChild>
              <Link to="/contact" data-testid="404-contact-btn">
                <Phone className="w-4 h-4 mr-2" />
                {t("notFound.contactUs", "Contact Us")}
              </Link>
            </Button>
          </div>
          
          {/* Back Link */}
          <button 
            onClick={() => window.history.back()} 
            className="mt-6 text-sm text-muted-foreground hover:text-primary flex items-center justify-center gap-1 mx-auto"
            data-testid="404-back-btn"
          >
            <ArrowLeft className="w-4 h-4" />
            {t("notFound.goBack", "Go back to previous page")}
          </button>
        </CardContent>
      </Card>
    </div>
  );
}
